import { Button, Paper, Grid } from '@material-ui/core';
import Box from '@mui/material/Box';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import { useHistory } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import jwt from 'jwt-decode';
import {
  fetchBorrowerDetails,
  getCashLedgerRequest,
  getInvestmentSummaryRequest,
  getPortfolioSummaryRequest,
  withdrawMoney,
} from './dashboardAction';
import InvestmentBox from './investmentBox';
import {
  getAuthToken,
  getUserDetails,
  getUserNewDetails,
} from '../../../utils/localStorage';

import BackgroundTheme from '../../../Common/P2P/Header/BackgroundTheme';
import MessageDialogBox from '../../../shared/messageDialogBox';
import InvestmentSummary from './investmentSummary';
import { AppState } from '../../../store/rootReducer';
import CashLedger from './cashLedger';
import BorrowerSummary from './borrowerSummary';
import ErrorMessage from '../../../Common/ErrorMessage';
import { logFirebaseEvent } from '../firebase';
import { P2P_REFER_ND_BTN, P2P_REFER_NOW_BTN } from '../firebase/constant';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import InvestIcon from '../../../utils/assests/new-invest-icon.jpg';
import DiverseIcon from '../../../utils/assests/new-divers-icon.jpg';
import EarnIcon from '../../../utils/assests/new-refer-and-earn.png';
import ReviewIconOne from '../../../utils/assests/new-rev-1.png';
import ReviewIconTwo from '../../../utils/assests/new-rev-2.png';
import ReviewIconThree from '../../../utils/assests/new-rev-3.png';
import CardImg from '../../../utils/assests/card-img.png';
import FooterLogo from '../../../utils/assests/footer-logo-st.png';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

const DashboardP2P = () => {
  const [progress, setProgress] = React.useState(0);
  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 0 : prevProgress + 10
      );
    }, 800);

    return () => {
      clearInterval(timer);
    };
  }, []);
  // const userDetails = JSON.parse(getUserNewDetails());
  // const { connectFetchKycData } = useSelector(
  //   (state: any) => state.connectBank
  // );
  let history = useHistory();
  let dispatch = useDispatch();
  const [user, setUser] = useState<any>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [type, setType] = useState<string>('');

  useEffect(() => {
    const token: any = getAuthToken();
    setUser(jwt(token)); // decode your token here
    dispatch(getPortfolioSummaryRequest());
    dispatch(getInvestmentSummaryRequest());
    dispatch(getCashLedgerRequest());
    dispatch(fetchBorrowerDetails());

    document.title = 'stashearn - dashboard';
  }, []);

  const handleClose = () => {
    setType('');
    setOpen(!open);
  };

  const handleReferNow = () => {
    logFirebaseEvent(P2P_REFER_ND_BTN);
    logFirebaseEvent(P2P_REFER_NOW_BTN);
    history.push({
      pathname: '/p2p/referEarn',
    });
    // setType('referral');
    // setOpen(!open);
  };

  const handleCalculator = () => {
    setType('calculator');
    setOpen(!open);
  };

  const {
    investmentSummary,
    cashLedgerSummary,
    dashboardSummary,
    borrowerResponse,
  } = useSelector((state: AppState) => state.dashboard);

  useEffect(() => {
    if (
      investmentSummary?.errors?.detail === 'journey not completed' ||
      cashLedgerSummary?.errors?.detail === 'journey not completed' ||
      dashboardSummary?.errors?.detail === 'journey not completed' ||
      borrowerResponse?.errors?.detail === 'journey not completed'
    ) {
      history.push('/');
      // localStorage.clear();
    } else if (
      investmentSummary?.errors?.detail === 'token expired' ||
      cashLedgerSummary?.errors?.detail === 'token expired' ||
      dashboardSummary?.errors?.detail === 'token expired' ||
      borrowerResponse?.errors?.detail === 'token expired'
    ) {
      setTimeout(() => {
        history.push('/');
        // localStorage.clear();
      }, 3000);
    }
    if (
      investmentSummary?.errors?.detail ||
      cashLedgerSummary?.errors?.detail ||
      dashboardSummary?.errors?.detail
    ) {
      setTimeout(() => {
        history.push('/');
      }, 3000);
    }
  }, [
    investmentSummary,
    cashLedgerSummary,
    borrowerResponse,
    dashboardSummary,
  ]);
  const getNow = () => {
    setType('getNow');
    setOpen(!open);
  };
  const toTitleCase = (str: any) => {
    if (str !== undefined && str !== null) {
      return str.replace(/\w\S*/g, (txt: any) => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
  };

  const handleBorrower = () => {
    history.push({
      pathname: '/p2p/borrowerInfo',
    });
  };

  const handleInvestmentSummary = () => {
    history.push({
      pathname: '/p2p/investmentSummaryInfo',
    });
  };

  const handleRecentTransaction = () => {
    history.push({
      pathname: '/p2p/recentTransactions',
    });
  };

  const handleInterestHeart = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      {!dashboardSummary?.data?.TotalPrincipalInvestment &&
        !dashboardSummary?.data?.RequestedInvestment && (
          <div className='text-name-style'>
            <Typography variant='h2'>
              Welcome &nbsp;
              <span>
                {user && toTitleCase(user?.full_name)?.split(' ')[0]}{' '}
              </span>
              {/*user?.full_name*/}
            </Typography>
          </div>
        )}
      {/* <div className='portfolio-container'>
        <div className='circular-progress'>
          <div className='value-container'>
            <p>
              10 <br /> Lakh
            </p>
          </div>
        </div>
      </div> */}

      {dashboardSummary &&
        !dashboardSummary?.data?.TotalPrincipalInvestment &&
        !dashboardSummary?.data?.RequestedInvestment && (
          <Box className='progressCircleNew'>
            <CircularProgress
              variant='determinate'
              value={60}
              size='12rem'
              thickness={5}
            />
            <p>
              <span>10</span> <br /> Lakh
            </p>
          </Box>
        )}

      {dashboardSummary &&
        !dashboardSummary?.data?.TotalPrincipalInvestment &&
        !dashboardSummary?.data?.RequestedInvestment &&
        !dashboardSummary?.data?.WithdrawableAmount && (
          <Box className='circleInfo'>
            <div className='redShape'></div>
            <Typography textAlign='center'>
              Available limit to invest
            </Typography>
          </Box>
        )}

      <BackgroundTheme>
        <Box>
          {/* <div className='name-image-row'>
            <div>
              <Avatar alt={user && user?.full_name} src='/static/images/avatar/1.jpg' />
            </div> 
          </div> */}
          <Box className=''>
            <InvestmentBox />
          </Box>
          {dashboardSummary?.data?.TotalPrincipalInvestment <= 0 && (
            <div>
              <Box className='sectionHeading'>
                <Typography variant='h2'>
                  Your best interest at heart
                </Typography>
              </Box>
              <Grid container spacing={4} className='TwoCardGrid'>
                <Grid item xs={6}>
                  <Card
                    onClick={handleInterestHeart}
                    className='redBorder TwoCard'
                  >
                    <CardContent>
                      <img src={InvestIcon} alt='' />

                      <Typography variant='h5'>
                        invest in
                        <br /> verified <br /> creditworthy <br /> borrowers
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6}>
                  <Card
                    onClick={handleInterestHeart}
                    className='redBorder TwoCard'
                  >
                    <CardContent>
                      <img src={DiverseIcon} alt='' />

                      <Typography variant='h5'>
                        diversified <br />
                        portfolio to grow
                        <br /> your money
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </div>
          )}
          <Card className='redBorder referCard'>
            <CardContent>
              <Grid container spacing={3} alignItems='center'>
                <Grid item>
                  <img src={EarnIcon} alt='' />
                </Grid>
                <Grid item>
                  <Typography variant='h4'>
                    Refer &amp; Earn
                    <br /> more with
                    <br /> friends
                  </Typography>
                </Grid>
              </Grid>

              <Box>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Typography align='center' variant='h5'>
                      Earn up to ₹10,000 <br /> by referring
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    {/* <Typography>
                      Lorem Ipsum is simply dummy text of the printing &
                      typesetting industry. when an unknown printer took a
                      galley of type and scrambled it to make a type specimen
                      book. It has survived not only five centuries, Lorem Ipsum
                      is simply dummy text of the printing & typesetting
                      industry. when an unknown printer took a galley of type
                      and scrambled it to make a type specimen book. It has
                      survived not only five centuries.
                    </Typography> */}
                  </Grid>
                  <Grid item xs={12} className='text-center'>
                    <Button
                      onClick={handleReferNow}
                      variant='contained'
                      className='btnWhite'
                    >
                      Refer now
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
          {dashboardSummary?.data?.TotalPrincipalInvestment > 0 && (
            <div>
              <Box className='sectionHeading'>
                <Typography variant='h2'>Review your investments</Typography>
              </Box>

              <Grid
                container
                spacing={3}
                justifyContent='center'
                alignItems='center'
                className='threeCards'
              >
                <Grid item xs={4}>
                  <Card
                    style={{ cursor: 'pointer' }}
                    onClick={handleBorrower}
                    className='redBorder'
                  >
                    <CardContent>
                      <img src={ReviewIconOne} alt='' />
                    </CardContent>
                  </Card>
                  <Typography>Borrower infomation</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Card
                    style={{ cursor: 'pointer' }}
                    onClick={handleInvestmentSummary}
                    className='redBorder'
                  >
                    <CardContent>
                      <img src={ReviewIconTwo} alt='' />
                    </CardContent>
                  </Card>
                  <Typography>Investment summary</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Card
                    style={{ cursor: 'pointer' }}
                    onClick={handleRecentTransaction}
                    className='redBorder'
                  >
                    <CardContent>
                      <img src={ReviewIconThree} alt='' />
                    </CardContent>
                  </Card>{' '}
                  <Typography>Recent transaction</Typography>
                </Grid>
              </Grid>
            </div>
          )}
         {/* <Box className='cardBox'>
            <Box>
              <Typography>
                Use the all-in-one card to meet
                <br />
                all of your financial needs & let your <br />
                investments keep growing!
              </Typography>
            </Box>
            <img src={CardImg} alt='' />
            <Box>
              <Button
                className='btnBlue fullWidth'
                variant='contained'
                color='primary'
                onClick={() => getNow()}
              >
                Get now
              </Button>
            </Box>
          </Box> */}

          {/* {borrowerResponse &&
          borrowerResponse?.status &&
          borrowerResponse?.data.length > 0 ? (
            <BorrowerSummary />
          ) : null}
          {investmentSummary &&
          investmentSummary?.status &&
          investmentSummary?.data?.current_investments.length > 0 ? (
            <InvestmentSummary />
          ) : null}
          {cashLedgerSummary &&
          cashLedgerSummary?.status &&
          cashLedgerSummary?.data.cash_ledger ? (
            <CashLedger />
          ) : null} */}

          <Box>
            <p className='poweredby'>
              <span>Powered by</span>

              <img src={FooterLogo} alt='' />
              {/* <img src='https://dummyimage.com/600x400/000/fff' alt='' /> */}
            </p>
            <p className='poweredText'>
              Partnered with LiquiLoans - RBI approved P2P <br /> NBFC.
              Investments are subject to risk. Risk of
              <br /> complete loss of principal exists.
            </p>
          </Box>
        </Box>
      </BackgroundTheme>

      <MessageDialogBox
        type={type}
        toggle={open}
        handleClose={handleClose}
        handleCalculator={handleCalculator}
        handleReferNow={handleReferNow}
        getNow={getNow}
      />
    </>
  );
};

export default DashboardP2P;
